import { useReportePropinasData } from "src/pages/propinas/pago-propinas/pdf/reporte";
import { TableSkeleton } from "src/shared/components/layout/skeleton/TableSkeleton/TableSkeleton";
import "./SectionPropinas.css"

type PropinasProps = {
    params: {
        fecha_inicio: string,
        fecha_fin: string,
        corte_id: string
    }
}


export const headers = [
    "Colaborador",
    "Estancia",
    "Alimentos",
    "Bebidas",
    "Sex&Spa",
    "Otros",
    "Propinas\npor venta",
    "Puntos\na pagar",
    "Comisión\nTarjeta",
    "Total",
]

function SectionPropinas({params}: PropinasProps) {
    const { loading, data, totals } = useReportePropinasData({...params, whiteSpace: false})
    
    return (
        <div>
            <p className="resumen-turno__subtitle">{"Propinas"}</p>
            <div>
                {loading ?
                <TableSkeleton headers={headers.map((value)=>{
                    return {value}
                })} />
                : data.length > 0 ?
                <div className="resumen-turno__tabla-propinas">
                    <div className="resumen-turno__tabla-propinas-thead resumen-turno__tabla-propinas-grid">
                        {headers.map((head, index)=>(
                            <div className={"resumen-turno__tabla-propinas-cell resumen-turno__tabla-propinas-th"} key={`thead-${index}`}>{head}</div>
                        ))}
                    </div>
                    <div className="resumen-turno__tabla-propinas-tbody">
                        {data.map(({values, section}, index)=>{
                            return (
                                <div className="resumen-turno__tabla-propinas-section" key={`tbody-section-${index}`}>
                                    <div className="resumen-turno__tabla-propinas-div">{section}</div>
                                    {values.map(({value}, valueIndex)=> {
                                        return (
                                            <div key={`row-${index}-${valueIndex}`} className="resumen-turno__tabla-propinas-grid resumen-turno__tabla-propinas-row">
                                                {value.map((cell, cellIndex)=>(
                                                    <div key={`cell-${index}-${valueIndex}-${cellIndex}`} className={"resumen-turno__tabla-propinas-cell resumen-turno__tabla-propinas-td"}>{cell}</div>
                                                ))}
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        })}
                    </div>
                    <div className="resumen-turno__tabla-propinas-tfooter resumen-turno__tabla-propinas-grid">
                        {totals.map((value, index)=>(
                            <div key={`cell-total${index}`} className={"resumen-turno__tabla-propinas-cell resumen-turno__tabla-propinas-total"}>{value}</div>
                        ))}
                    </div>
                </div>
                : <div className="resumen-truno__empty-table">Sin propinas en turno</div>}
            </div>
        </div>
    )
}

export default SectionPropinas